import { PageShell } from "../components/PageShell";
import { PageHero } from "../components/PageHero";
import { DEVELOPER_DETAILS } from "../data/site";

export default function DevelopersPage() {
  return (
    <PageShell>
      <PageHero
        eyebrow="Our Partners"
        title="Authorised channel partners of Dubai's"
        italic="leading developers"
        subtitle="We work directly with the UAE's most reputable developers, giving our clients transparent access to launch inventory and construction-linked payment plans."
      />

      <section className="py-16 md:py-24 px-6 md:px-12">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-4" data-testid="developers-grid">
          {DEVELOPER_DETAILS.map((d, i) => (
            <div key={d.name} className="glass rounded-2xl p-6 md:p-8 flex items-start gap-5 hover:border-[#c5a059]/40 transition" data-testid={`developer-${i}`}>
              <div className="text-[10px] tracking-[0.4em] text-[#c5a059] uppercase pt-2 shrink-0">0{i < 9 ? i + 1 : (i + 1)}</div>
              <div>
                <h3 className="font-serif-display text-2xl mb-1">{d.name}</h3>
                <p className="text-white/50 italic text-sm mb-3">{d.tag}</p>
                <div className="flex flex-wrap items-center gap-x-4 gap-y-1 text-xs">
                  <span className="text-white/70">{d.stat}</span>
                  <span className="text-white/30">·</span>
                  <span className="text-white/50">Est. {d.founded}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </PageShell>
  );
}
